import { render, staticRenderFns } from "./BookingCheckout.vue?vue&type=template&id=748f355a&scoped=true&"
import script from "./BookingCheckout.vue?vue&type=script&lang=js&"
export * from "./BookingCheckout.vue?vue&type=script&lang=js&"
import style0 from "./BookingCheckout.vue?vue&type=style&index=0&id=748f355a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748f355a",
  null
  
)

export default component.exports